/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioWaveIcon24Solid = forwardRef('MediaAudioWaveIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.125 3a1.125 1.125 0 0 0-2.25 0v18a1.125 1.125 0 0 0 2.25 0V3Z" }),
        React.createElement("path", { d: "M19.125 6a1.125 1.125 0 0 0-2.25 0v12a1.125 1.125 0 0 0 2.25 0V6Z" }),
        React.createElement("path", { d: "M23.125 10a1.125 1.125 0 0 0-2.25 0v4a1.125 1.125 0 0 0 2.25 0v-4Z" }),
        React.createElement("path", { d: "M14 7.875c.621 0 1.125.504 1.125 1.125v6a1.125 1.125 0 0 1-2.25 0V9c0-.621.504-1.125 1.125-1.125Z" }),
        React.createElement("path", { d: "M6 5.875c.621 0 1.125.504 1.125 1.125v10a1.125 1.125 0 0 1-2.25 0V7c0-.621.504-1.125 1.125-1.125Z" }),
        React.createElement("path", { d: "M3.125 10.5a1.125 1.125 0 0 0-2.25 0v3a1.125 1.125 0 0 0 2.25 0v-3Z" })));
});
